const ERROR_TYPE = (exports.ERROR_TYPE = {
  SYSTEM: 100,
  APPLICATION: 101,
  BUSINESS_RULE: 102,
  FIELD_VALIDATION: 103,
});

exports.ERROR_TYPE_NAME = {
  [ERROR_TYPE.SYSTEM]: "System",
  [ERROR_TYPE.APPLICATION]: "Application",
  [ERROR_TYPE.BUSINESS_RULE]: "BusinessRule",
  [ERROR_TYPE.FIELD_VALIDATION]: "FieldValidation",
};
